import { Component, OnInit } from "@angular/core";
import { DeviceMaintenanceService } from "./device-maintenance.service";
import { MAINTENANCE_DEVICE_FOLDERNAME } from "src/app/utils/constant";
import { DialogService, LanguageService, HelperService } from "src/app/services";
import { environment } from "src/environments/environment";
import { of as observableOf, Subscription } from "rxjs";
import { MediaObserver } from "@angular/flex-layout";
import { catchError, finalize } from "rxjs/operators";
import * as _ from "lodash";
import { MatDialogRef } from "@angular/material/dialog";
import { DeviceMaintenanceFilterComponent } from "./device-maintenance-filter/device-maintenance-filter.component";

@Component({
  selector: 'esc-device-maintenance',
  templateUrl: './device-maintenance.component.html',
  styleUrls: ['./device-maintenance.component.scss']
})
export class DeviceMaintenanceComponent implements OnInit {
  public loading = {
    init: false,
    detail: false,
    more: false,
    export: false,
    import: false,
    error: false,
    detailError: false
  };
  private listSub: Subscription;
  private detailSub: Subscription;
  public listData = [];
  public locations = [];
  public detailData;
  public columns = ["code", "device_type", "is_active"];
  public detailKeys = ["code", "branch", "device_location", "device_type", "terminal_is_registered", "is_active"];
  // public excelCols = ["TERMINAL ID", "DEVICE DESCRIPTION", "IMEI", "LOCATION CODE","LOCATION DESCRIPTION", "BRANCH CODE", "BRANCH NAME", "REGISTERED", "STATUS"];
  public excelCols = ['SERIAL NO.', 'MANUFACTURER', 'TID', 'MERCHANT ADDRESS', 'BRANCH CODE', 'LOCATION CODE']
  private currentFilters;
  private previousFilters;
  public listLength = 0;
  public mode;
  public modifying: Boolean = false;
  public deselect: Boolean = false;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public folderName = MAINTENANCE_DEVICE_FOLDERNAME;

  constructor(
    public media: MediaObserver,
    private deviceMntSvc: DeviceMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private helper: HelperService
  ) {}

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.getListData();
    this.getLocations();
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  download(ev) {
    let dialogRef = this.dialogService.loading();
    this.listSub = this.deviceMntSvc.genericMaintenanceDownload(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.openDownloadMenu(res.data);
          dialogRef.close();
        }
      });
  }

  getLocations() {
    this.locations = []
    this.deviceMntSvc.getLocations(this.currentFilters).pipe(
      finalize(() => {
        return observableOf(null);
      }),
      catchError(err => {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, "value") && _.toLower(res.value) == _.toLower("Success")) {
          this.locations = this.locations.concat(res.data);
        }
      });
  }

  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }
    this.listSub = this.deviceMntSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError(err => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, "value") && _.toLower(res.value) == _.toLower("Success")) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.toNumber(_.get(res, "count"));
        }
      });
  }

  getMore(event) {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    if (event) {
      this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
      this.getListData();
    }
  }

  getDetail(data) {
    if(data) {
      let temp = this.listData.filter(e => {
        return e.id == data.id;
      })
      this.detailData = _.clone(temp[0]);
      this.deselect = false;
    }
  }

  addNew(event) {
    this.closeDetail(null);
    this.modifying = true;
    this.mode = "Add";
  }

  edit(event) {
    this.modifying = true;
  }

  searchBy(keyword) {
    this.currentFilters.web_filter.keyword = _.clone(keyword);
    this.refresh(true);
  }

  openFilter(ev) {
    let dialogRef: MatDialogRef<DeviceMaintenanceFilterComponent>;
    dialogRef = this.dialogService.openDialog(DeviceMaintenanceFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'previousFilters') || _.get(this, 'currentFilters')
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        this.previousFilters = _.cloneDeep(selectedFilters);

        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status.code');
        this.refresh(null);
      }
    })
  }

  saving(event) {
    this.loading.detail = true;
    if(_.has(event[0], 'code')) {
      let obj = _.get(event, '[0]');
      this.detailData = _.clone(obj);
    } 
    else if(!event) {
      this.loading.detail = false;
    }
  }

  closeDetail(event) {
    this.detailData = null;
    this.deselect = true;
  }

  closeForm(event) {
    this.modifying = false;
    this.mode = null;
    if(event) {
      this.refresh(event);
    }
  }

  refresh(event) {
    if (!event) {
      this.closeDetail(null);
    }
    this.listData = [];
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(INITIAL_OPTIONS.web_filter.offset);
    this.getListData();
    this.getLocations();
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    limit: 50,
    offset: 0,
    keyword: "",
    end_date: "",
    is_asc: 1,
    status: null
  }
};